import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from 'pages/document/page/components/StyledComponents';

export const ApprovalStampLayout = styled('div', { label: 'ApprovalStampLayout' })(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: '100%',
  width: '100%',
  zIndex: PAGE_Z_INDEX.APPROVAL_STAMP,
}));

export const ApprovalStampDraggable = styled(ButtonBase, { label: 'ApprovalStampDraggable' })(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  transition: 'opacity 250ms',
  transformOrigin: '0 0',
  backgroundColor: 'transparent',

  '&:hover': {
    cursor: 'move',
  },

  '&.visible': {
    opacity: 1,

    '&:hover': {
      opacity: 1,
      cursor: 'default',
    },
  },
}));
